export default "__VITE_ASSET__BQhdz687__"